function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Alces Prime.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/


import React from 'react';
import { toClass, withProps, wrapDisplayName } from 'recompose';
import PopoverConfirmation from './PopoverConfirmation';
export default function withConfirmation(config) {
  return function (WrappedComponent) {
    // eslint-disable-next-line no-param-reassign
    WrappedComponent = toClass(WrappedComponent);

    var Wrapper = /*#__PURE__*/function (_React$Component) {
      _inherits(Wrapper, _React$Component);

      function Wrapper() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Wrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Wrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          submitting: false,
          showingConfirmation: false
        });

        _defineProperty(_assertThisInitialized(_this), "handleShowConfirmation", function (event) {
          _this.setState({
            showingConfirmation: true
          });

          if (_this.props.onConfirmationShown) {
            _this.props.onConfirmationShown(event);
          }
        });

        _defineProperty(_assertThisInitialized(_this), "handleHideConfirmation", function () {
          _this.setState({
            showingConfirmation: false
          });
        });

        _defineProperty(_assertThisInitialized(_this), "handleConfirmation", function (event) {
          _this.handleHideConfirmation();

          _this.setState({
            submitting: true
          });

          return _this.props.onConfirm(event, _this.props).then(function (r) {
            _this.setState({
              submitting: false
            });

            return r;
          })["catch"](function (e) {
            _this.setState({
              submitting: false
            });

            Promise.reject(e);
          });
        });

        return _this;
      }

      _createClass(Wrapper, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              confirmButtonColor = _this$props.confirmButtonColor,
              confirmButtonText = _this$props.confirmButtonText,
              confirmText = _this$props.confirmText,
              placement = _this$props.placement,
              id = _this$props.id,
              onConfirm = _this$props.onConfirm,
              onConfirmationShown = _this$props.onConfirmationShown,
              rest = _objectWithoutProperties(_this$props, ["confirmButtonColor", "confirmButtonText", "confirmText", "placement", "id", "onConfirm", "onConfirmationShown"]);

          var confirmationPopover = /*#__PURE__*/React.createElement(PopoverConfirmation, {
            confirmColor: confirmButtonColor,
            confirmText: confirmButtonText,
            onConfirmation: this.handleConfirmation,
            onHide: this.handleHideConfirmation,
            placement: placement,
            show: this.state.showingConfirmation,
            target: id
          }, confirmText);
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
            confirmationPopover: confirmationPopover,
            id: id,
            onClick: this.handleShowConfirmation,
            ref: function ref(el) {
              _this2.button = el;
            },
            showingConfirmation: this.state.showingConfirmation,
            submitting: this.state.submitting
          }));
        }
      }]);

      return Wrapper;
    }(React.Component);

    Wrapper.displayName = wrapDisplayName(WrappedComponent, 'withConfirmation');
    return withProps(config)(Wrapper);
  };
}